import React, { useMemo, useState } from 'react';
import { useRecoilValue } from 'recoil';
import InventorySelector from '../../../recoil/cashout/InventorySelector';
import ItemConvertCatalogSelector from '../../../recoil/cashout/ItemConvertCatalogSelector';
import DiamondBalance from '../common/DiamondBalance';
import ItemConvertCatalogHeader from './ItemConvertCatalogHeader';
import { filterItemConvertByInventory } from '../../helpers/ProductUtils';
import ItemConvertCatalogPackages from './ItemConvertCatalogPackages';
import ItemConvertConfirmationModal from './modals/ItemConvertConfirmationModal';

export default function ItemConvert() {
  const packages = useRecoilValue(ItemConvertCatalogSelector);
  const inventory = useRecoilValue(InventorySelector);

  const [selectedPackage, setSelectedPackage] = useState(null);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const filteredPackages = useMemo(
    () => filterItemConvertByInventory(packages, inventory),
    [packages, inventory],
  );

  const handleClaim = (pkg) => {
    setSelectedPackage(pkg);
    setShowConfirmationModal(true);
  };

  return (
    <div>
      <DiamondBalance />

      <ItemConvertCatalogHeader />

      <ItemConvertCatalogPackages
        packages={filteredPackages}
        onClick={handleClaim}
      />

      {showConfirmationModal && (
        <ItemConvertConfirmationModal
          selectedPackage={selectedPackage}
          onClose={() => setShowConfirmationModal(false)}
        />
      )}
    </div>
  );
}
